import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import RRD_logo from "../../assets/logo/rrd.png";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer-bg pt-5">
      <Container>
        <Row className="gy-4">
          {/* Logo + Social */}
          <Col md={4} sm={12} className="text-center text-md-start">
            <div className="m-auto w-100">
              <img src={RRD_logo} alt="RRD Rajparis" className="footer-logo mb-3" />
            </div>
            <p className="footer-light-text small">
            With years of experience in real estate and construction, we are committed to building homes that reflect quality, trust, and comfort.

            </p>
            <div className="contact-container"> 
              <h5 className="fw-bold">Reach out us</h5>
              <div> <a className="cursor-pointer email-tag footer-light-text" href="mailto:rajparisredevelopmentrrd@gmail.com" >
                      rajparisredevelopmentrrd@gmail.com 
                    </a> 
              </div> 
              <div>
                   <a className="cursor-pointer email-tag footer-light-text" href="tel:+918939714384" > 
                    +91 89397 14384 </a> 
              </div> 
              <div>
                   <a className="cursor-pointer email-tag footer-light-text" href="tel:+918667266354" > 
                    +91 86672 66354 </a> 
              </div> 
            </div>
            <ul className="social-icons mt-3 justify-content-center justify-content-md-start">
              <li>
                <a href="https://www.facebook.com/share/17fuj3LCsz/" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/rajparis_redevelopment/" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </li>
            </ul>
            
          </Col>

          {/* Address + Links */}
          <Col md={4} sm={12} className="footer-light-text">
            <h5 className="fw-bold mb-3">Address</h5>
            <p className="mb-1">Head Office –</p>
            <p className="small">
              No. 526, 7E, 7th Floor, Century Plaza,Anna Salai, <br></br>
              Chennai – 600 018.
            </p>
            <div className="mt-4">
              <h5 className="fw-bold mb-3">Quick Links</h5>
              <Row>
                <Col xs={6}>
                  <a href="/home" className="footer-link">Home</a><br />
                  <a href="/projects" className="footer-link">Projects</a><br/>
                  <a href="/aboutus" className="footer-link">About Us</a>
                </Col>
                <Col xs={6}>
                  <a href="/joint-venture" className="footer-link">Ventures</a><br />
                  <a href="/contactus" className="footer-link">Contact Us</a><br/>
                  <a href="/privacy" className="footer-link">Privacy Policy</a>
                </Col>
              </Row>
            </div>
          </Col>

          {/* Contact Form */}
          <Col md={4} sm={12}>
            <h5 className="fw-bold mb-3 footer-light-text">Our Location</h5>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3517.401762083277!2d80.24767589999999!3d13.044870099999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52664f3d273159%3A0x459a88fc54f23544!2sRajparis%20Civil%20Constructions!5e1!3m2!1sen!2sin!4v1767839534584!5m2!1sen!2sin" min-width="300" height="300" style={{width:"100%",border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Col>
        </Row>
      </Container>

      {/* Bottom Bar */}
      <div className="footer-bottom border-top mt-4 pt-3 pb-2 text-center">
        <p className="footer-light-textm-0 small">
          2025 © RRD Rajparis. All Rights Reserved. |{" "}
          <a href="/privacy" className="footer-light-text">
            Privacy & Policy
          </a>
        </p>
      </div>
    </footer>
  );
}
